import Vue from "vue";
import VueResource from "vue-resource";
Vue.use(VueResource);

// "https://cn-cloud.tenda.com.cn" 正式环境访问
// "https://test-cn.cloud.tenda.com.cn" 测试环境访问
// const baseurl = process.env.NODE_ENV === 'test' ? "http://test-cn.cloud.tenda.com.cn" : "https://cn-cloud.tenda.com.cn"
const baseurl = ''

class Http {

  get(url, data) {
    if (url.indexOf("/") != 0) {
      url = "/" + url;
    }
    if (url.indexOf("?") != -1) {
      url += "&rand=" + Math.random();
    } else {
      url += "?rand=" + Math.random();
    }
    const Authorizationstr = sessionStorage.getItem("Authorization") || "";
    const appid = sessionStorage.getItem('appid')
    let _this = this
    return new Promise((resolve, reject) => {
      Vue.http({
        url: baseurl + url,
        method: "GET",
        params: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "Authorization": Authorizationstr,
          'App-Id': appid,
          'Language': sessionStorage.getItem('language-region')
        },
        timeout: 60000,
      }).then(
        function (res) {
          let data = res.body;
          if(+data.code === 100410){
            // 刷新token
            _this.$refresh()
          }
          if(+data.code === 100411){
            // Token验证不通过或已失效 跳转到登录页面
            _this.$message.error(_("Token验证不通过或已失效，请重新登录！"))
            window.location.href = 'login.html'
          }
          if (+data.code === 1000) {
            //超时
            window.location.reload(true);
            return;
          }
          resolve(data);
        },
        function (res) {
          reject(res);
        }
      );
    });
  }
  //提交模块数据 message为false时，不会有提示信息
  postModule(url, data, message, tip) {
    let moduleArr = [];
    for (let prop in data) {
      moduleArr.push(prop);
    }
    return this.$post(
      url,
      data,
      message,
      tip
    );
  }
  //提交其他url数据
  post(url, data, message, tip ) {
    const Authorizationstr = sessionStorage.getItem("Authorization") || "";
    const appid = sessionStorage.getItem('appid')
    if (url.indexOf("/") != 0) {
      url = "/" + url;
    }
    let _this = this;
    return new Promise((resolve, reject) => {
      Vue.http({
        url: baseurl + url,
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "Authorization": Authorizationstr,
          'App-Id': appid,
          'Language': sessionStorage.getItem('language-region')
        },
        timeout: 50000,
        body: data,
        // emulateJSON: true  是否为application/x-www-form-urlencoded
      }).then(
        /**
         * code
         * 0 设置成功
         * 1 设置错误
         */
        function (res) {
          let data = res.body;
          let code = +data.code;
          if (code === 1000) {
            //超时
            window.location.reload(true);
            return;
          }
          if(code === 100410){
            // 刷新token
            _this.$refresh()
          }
          if(code === 100411){
            // Token验证不通过或已失效 跳转到登录页面
            _this.$message.error(_("Token验证不通过或已失效，请重新登录！"))
            window.location.href = 'login.html'
          }
          //!TODO: 统一处理返回的code
          if (code == 0) {
            if (message !== false) {
              //false时不需要提示
              _this.$message &&
                _this.$message.success(message || _("Saved successfully"));
            }
          } else if (code == 1) {
            if (tip !== false) {
              _this.$message.error(_("Failed to save"));
            }
          }
          resolve(data);
        },
        function (res) {
          reject(res);
        }
      );
    });
  }

  jsonp(url) {
    return new Promise((resolve) => {
      Vue.http
        .jsonp(url + Math.random())
        .then(
          () => { },
          e => {
            if (e.status == 0) {
              resolve(url);
            }
          }
        );
    });
  }

  put(url, data, message, tip) {
    const Authorizationstr = sessionStorage.getItem("Authorization") || "";
    const appid = sessionStorage.getItem('appid')
    if (url.indexOf("/") != 0) {
      url = "/" + url;
    }
    let _this = this;
    return new Promise((resolve, reject) => {
      Vue.http({
        url: baseurl + url,
        method: "PUT",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "Authorization": Authorizationstr,
          'App-Id': appid,
          'Language': sessionStorage.getItem('language-region')
        },
        timeout: 60000,
        body: data,
        // emulateJSON: true  是否为application/x-www-form-urlencoded
      }).then(
        /**
         * code
         * 0 设置成功
         * 1 设置错误
         */

        function (res) {
          let data = res.body;
          let code = +data.code;
          if (code === 1000) {
            //超时
            window.location.reload(true);
            return;
          }
          if(code === 100410){
            // 刷新token
            _this.$refresh()
          }
          if(code === 100411){
            // Token验证不通过或已失效 跳转到登录页面
            _this.$message.error(_("Token验证不通过或已失效，请重新登录！"))
            window.location.href = 'login.html'
          }
          //!TODO: 统一处理返回的code
          if (code == 0) {
            if (message !== false) {
              //false时不需要提示
              _this.$message &&
                _this.$message.success(message || _("Saved successfully"));
            }
          } else if (code == 1) {
            if (tip !== false) {
              _this.$message.error(_("Failed to save"));
            }
          }
          resolve(data);
        },
        function (res) {
          reject(res);
        }
      );
    });
  }
  delete(url,data) {
    if (url.indexOf("/") != 0) {
      url = "/" + url;
    }
    let _this = this
    const Authorizationstr = sessionStorage.getItem("Authorization") || "";
    const appid = sessionStorage.getItem('appid')
    return new Promise((resolve, reject) => {
      Vue.http({
        url: baseurl + url,
        method: "DELETE",
        params: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "Authorization": Authorizationstr,
          'App-Id': appid,
          'Language': sessionStorage.getItem('language-region')
        },
        timeout: 60000,
      }).then(
        function (res) {
          let data = res.body;
          if(+data.code === 100410){
            // 刷新token
            _this.$refresh()
          }
          if(+data.code === 100411){
            // Token验证不通过或已失效 跳转到登录页面
            _this.$message.error(_("Token验证不通过或已失效，请重新登录！"))
            window.location.href = 'login.html'
          }
          if (+data.code === 1000) {
            //超时
            window.location.reload(true);
            return;
          }

          resolve(data);
        },
        function (res) {
          reject(res);
        }
      );
    });
  }
  //刷新令牌
  refresh(){
    const Authorizationstr = sessionStorage.getItem("Authorization").slice(7) || "";
    this.$post("/td/td-iot-api/iot/token/refresh/v1", {access_token: Authorizationstr }, false).then((res) => {
      let code = +res.code;
      if (code === 0) {
        sessionStorage.setItem("Authorization", `Bearer ${res.data.access_token}`);
      } else {
        this.$message.error(_("刷新token失败， 请重新登录！"))
        window.location.href = 'login.html'
      }
    });
  }
  //下载文件
  downFile(url){
    const dom = document.createElement("a");
    dom.href = url;
    dom.style.display = "none";
    document.body.appendChild(dom);
    dom.click();
    dom.parentNode.removeChild(dom);
  }
}

let http = new Http();
export { http };
